// fmtTime.mjs — 「读者本地时刻」的**唯一**印法（第二百四十七批复审，SB-190 步 5）。
//
// 它原本是 TicketDetailView.jsx 里的一个导出函数，十几处页面从那里引。钟点条
// （ResponseDeadlineBar.jsx）也要它——而 TicketDetailView 又引钟点条：两个 .jsx 互引成环。
// 环今天能跑（fmtTime 是提升的函数声明、只在渲染时调用；本仓的打包器 esbuild 对互引环
// **不出声**，换成 Rollup 才会报 CIRCULAR_DEPENDENCY——所以它是复审读源码找到的，不是
// 构建报的），但任何一侧在模块求值期用到另一侧的那一刻它就断，且断在一个没有任何判据
// 看着的地方。一个纯函数不该住在一个组件文件里；搬出来，环没有了，TicketDetailView 保留
// `export { fmtTime }` 让既有调用方原地不动。
//
// 语义一个字不改：无值 ⇒ '—'；按读者语言选 zh-CN / en-US；任何 Date 异常 ⇒ '—'
// （一个坏的毫秒数印出来的是破折号，不是崩掉的页面）。
export function fmtTime(ms, lang) {
  if (!ms) return '—';
  try {
    return new Date(Number(ms)).toLocaleString(lang === 'zh' ? 'zh-CN' : 'en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}
